/**
 * Parameter option data-type filtering
 *
 * Dropdowns that bind a configuration field to a Revit parameter should only
 * offer parameters whose data type can hold the field's value — a Length bolt
 * diameter must not offer Text parameters, a Yes/No toggle must not offer
 * Length ones. Options with an unknown data type stay visible on purpose:
 * older plugin builds report no type at all, and free-typed parameter names
 * carry none either, so hiding them would silently break existing setups.
 */

export const TEXT_PARAMETER_DATA_TYPES = ['TEXT', 'MULTILINETEXT', 'URL'] as const;

export function toRevitParameterType(bindingKind: 'type' | 'instance'): 'Type' | 'Instance' {
  return bindingKind === 'instance' ? 'Instance' : 'Type';
}

export function filterParameterOptionsByDataType<T extends { dataType?: string }>(
  options: T[],
  allowedDataTypes: readonly string[]
): T[] {
  const allowed = new Set(allowedDataTypes.map((token) => token.toUpperCase()));
  return options.filter((option) => {
    const token = option.dataType?.trim().toUpperCase();
    return !token || allowed.has(token);
  });
}

export function filterTextParameterOptions<T extends { dataType?: string }>(options: T[]): T[] {
  return filterParameterOptionsByDataType(options, TEXT_PARAMETER_DATA_TYPES);
}
